import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Ocorrência',
  path: '/pessoal/pestipoocorrencia',
  name: 'pestipoocorrencia',
  component: () => import('@/views/pessoal/pestipoocorrencia/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEOCORRENCIANOVO_MENU_1400700198],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Ocorrência',
  path: '/pessoal/pestipoocorrencia/cadastro/:id?',
  parent: 'pestipoocorrencia',
  name: 'pestipoocorrencia_create',
  component: () => import('@/views/pessoal/pestipoocorrencia/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEOCORRENCIANOVO_MENU_1400700198],
  },
  goesToMenu: true,
 },
]
